export const localStorageKeys = {
  ONBOARDING_FIRST_VISIT: 'TB/onboarding-first-visit',
  ONBOARDING_TUTORIAL: 'TB/onboarding-tutorial',
  AMPLITUDE_FIRST_SESSION: 'TB/amplitude-first-session',
  INSTALL_APP_DISMISSED1: 'TB/install-app-dismissed1',
  INSTALL_APP_DISMISSED2: 'TB/install-app-dismissed2',
  GUEST_MARKETPLACE: 'TB/guest-marketplace',
  MULTI_ROBOT_POPUP_SHOWN: 'TB/multi-robot-popup-shown',
  EVENT_POPUP_HIDE_UNTIL: 'TB/event-popup-hide-until',
};

export const localStorageValues = {
  STARTED: 'started',
  FINISHED: 'finished',
  DISMISSED: 'dismissed',
};
